
import './App.css';
import './Principal.css';

import Lector from "./components/lector"


export default function App() {
  return (
    <div>
   
       <Lector/>
      
    </div>
  );
}
